export default __webpack_public_path__ + "static/media/teste-gratis.e0efe130.svg";